module.exports = __webpack_public_path__ + "assets/img/title-f34b72e9.png";